import { QueryEntity } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { OrderItemsState, OrderItemsStore } from './order-items.store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {OrderListItemModel} from '../../../models/order/order-list-item.model';
import {IItemsQueryInterface} from '../../../interfaces/items/items-query.interface';
import {TableColumn} from '../../../models/table-column';

@Injectable({
  providedIn: 'root',
})
export class OrderItemsQuery extends QueryEntity<OrderItemsState> implements IItemsQueryInterface<OrderListItemModel> {
  page$;
  pageSize$;
  lastPage$;
  selectedOrder$: Observable<string>;

  constructor(protected store: OrderItemsStore) {
    super(store);
    this.page$ = this.select((state) => state.page);
    this.pageSize$ = this.select((state) => state.pageSize);
    this.lastPage$ = this.select((state) => state.lastPage);
    this.selectedOrder$ = this.selectActive().pipe(
      map((selectedOrder) => selectedOrder?.orderNumber
          ? selectedOrder.orderNumber + ' - ' + selectedOrder.orderName
          : '')
    );
  }

  getFilterValue(): string {
    return this.getValue()?.filterValue;
  }

  selectFilterValue(): Observable<string> {
    throw new Error('Method not implemented.');
  }

  getRowCssClass(item: OrderListItemModel): string {
    return '';
    }

  getActiveText(): string {
    return this.getActive()?.orderNumber + ' - ' + this.getActive()?.orderName;
  }

  getFilterColumns(): TableColumn[] {
    return [];
  }

  getItemText(item: OrderListItemModel, key: string): string {
    return item?.orderNumber + ' - ' + item?.orderName;
  }

  getItemValue(item: OrderListItemModel, key: string): any {
    return item?.orderNumber + ' - ' + item?.orderName;
  }

  getItems(): OrderListItemModel[] {
    return this.getAll();
  }

  getLastPage(): boolean {
    return this.getValue()?.lastPage;
  }

  getLoading(): boolean {
    return this.getValue()?.loading;
  }

  getTableColumns(): TableColumn[] {
    return [];
  }

  selectFilterColumns(): Observable<TableColumn[]> {
    return undefined;
  }

  selectItems(): Observable<OrderListItemModel[]> {
    return this.selectAll();
  }

  selectLastPage(): Observable<boolean> {
    return this.select(state => state.lastPage);
  }

  selectTableColumns(): Observable<TableColumn[]> {
    return undefined;
  }
}
